import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval } from 'rxjs';
import { Deployment } from 'src/app/core/models/deployment';
import { Entities } from 'src/app/core/models/globals';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';

@Component({
  selector: 'app-user-parent-list',
  templateUrl: './user-parent-list.component.html',
  styleUrls: ['./user-parent-list.component.scss']
})
export class UserParentListComponent implements OnInit {

  deployments: Deployment[];
  currentEntity;
  dataEmpty: boolean = false;
  dataReloadSubscription: Subscription;
  userDepCheck: Subscription;
  userDeploymentListSub: Subscription;

  constructor(
    private navService: NavigationService,
    private depService: DeploymentService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private headerService: HeaderService,
    private syncConfig: SyncConfigService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.navService.subNavData(Entities.Users);
    this.loadUserList();
    this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval + 15000).subscribe((x) => {
      this.loadUserList();
    });
  }

  loadUserList(){
    if(this.userDeploymentListSub) this.userDeploymentListSub.unsubscribe();
    this.userDeploymentListSub = this.depService
    .getAllDeploymentsForUser(
    )
    .subscribe((data) => {
      if(data == null){
        this.spinner.hide()
        this.dataEmpty = true;
      } else {
        this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
        // this.depService.checkUserDepAccess();
        this.deployments = this.deployments.filter(x => x.status == 'Active')
        this.headerService.updateDeploymentList(this.deployments);
        if(this.deployments.length == 0) {
          this.dataEmpty = true;
          this.spinner.hide();
        } else {
          this.dataEmpty = false;
          if (!this.deployments[1]) {
            this.redirectTo(this.deployments[0]);
          }
          this.spinner.hide();
        }
      }
    });
  }
  
  ngOnDestroy(): void {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if(this.userDepCheck) this.userDepCheck.unsubscribe();
    if(this.userDeploymentListSub) this.userDeploymentListSub.unsubscribe();
  }

  redirectTo(deployment: Deployment) {
    this.router.navigate([deployment.cloud, deployment.name], {
      relativeTo: this.route,
    });
  }

}
